import type { ActionTree } from 'vuex';
import type { IThemeState } from './theme.types';
import { EThemeAction, EThemeMutation } from './theme.types';
import { ThemeService } from '@signing-page/api/theme/services/theme.service';
import type { ITheme } from '@signing-page/api/theme/types/theme';
import type { IRootState } from '@signing-page/store/store';

export const actions: ActionTree<IThemeState, IRootState> = {
  async [EThemeAction.Load]({ commit }, documentId: string) {
    try {
      const theme: ITheme = await ThemeService.load(documentId);
      commit(EThemeMutation.SetTheme, theme);
    } catch (e) {
      console.error(e);
    }
  },
};
